import type { CollectionModel } from "@/features/collections/api/models/CollectionModel";
import { useHTTP, useHTTPMutation, type HTTPResponse } from "@/lib/http";
import { useQueryClient, type MutationFunction } from "@tanstack/react-query";

export interface CollectionCreateRequestModel {
	readonly name: string;
}

export const useCollectionCreate = () => {
	const http = useHTTP("Required");
	const queryClient = useQueryClient();

	const mutationFn: MutationFunction<HTTPResponse<CollectionModel>, CollectionCreateRequestModel> = requestModel => {
		return http<CollectionModel, CollectionCreateRequestModel>({
			method: "POST",
			url: "/collection",
			body: requestModel
		});
	};

	return useHTTPMutation({
		mutationFn,
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["collections"] });
			queryClient.invalidateQueries({ queryKey: ["collectionsPerformanceDelta"] });
		}
	});
};
